import React, { useEffect, useRef, useState } from 'react'

const API_BASE = (process.env.REACT_APP_API_BASEURL || '').replace(/\/api\/?$/, '')

const INITIAL_VISIBLE = 60
const LOAD_MORE_COUNT = 60

const getGameImageUrl = (item: any) => {
  const url = item?.game_images || item?.image_url || item?.game_image
  return url && typeof url === 'string' && url.trim() !== '' ? url.trim() : ''
}

const getWebpUrl = (item: any): string | null => {
  const url = item?.game_images_webp
  return url && typeof url === 'string' && url.trim() !== '' ? url.trim() : null
}

const resolveImage = (item: any, overrideImages?: Record<string, string>, useCustomImage?: Record<string, boolean>) => {
  const gid = item?.game_identifier || item?.identifier || item?._id
  if (gid && overrideImages?.[gid] && useCustomImage?.[gid]) {
    const override = overrideImages[gid]
    return override.startsWith('http') ? override : `${API_BASE}${override}`
  }
  return getGameImageUrl(item)
}

const CasinoListItemInt = (props: any) => {
  const overrideImages = props.overrideImages
  const useCustomImage = props.useCustomImage
  const games = props.games || []

  const [visible, setVisible] = useState(INITIAL_VISIBLE)
  const [failedImages, setFailedImages] = useState<Set<string>>(new Set())
  const loaderRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setVisible(INITIAL_VISIBLE)
    setFailedImages(new Set())
  }, [games])

  useEffect(() => {
    if (visible >= games.length) return
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return
        setVisible((prev) => Math.min(prev + LOAD_MORE_COUNT, games.length))
      },
      { rootMargin: '100px', threshold: 0 }
    )
    const el = loaderRef.current
    if (el) observer.observe(el)
    return () => observer.disconnect()
  }, [visible, games.length])

  const visibleGames = games.slice(0, visible)
  const hasMore = visible < games.length

  return (
    <>
      {visibleGames.map((Item: any, key: number) => {
        const imageUrl = resolveImage(Item, overrideImages, useCustomImage)
        const webpUrl = getWebpUrl(Item)
        const didFail = imageUrl && failedImages.has(imageUrl)
        const handleImageError = () => {
          if (imageUrl) {
            setFailedImages((prev) =>
              prev.has(imageUrl) ? prev : new Set(Array.from(prev).concat(imageUrl))
            )
          }
        }
        return (
          <div
            className="casino-list-item"
            key={Item.identifier ?? Item.game_id ?? key}
            onClick={(e) => { e.preventDefault(); props.setGamePlay(Item) }}
            title={`${Item.game_name ?? ''} - lotusbookio`}
          >
            <a href="#">
              <div className={`casino-list-item-banner${didFail ? ' casino-list-item-banner--blank' : ''}`}>
                {!didFail && imageUrl && (
                  webpUrl ? (
                    <picture>
                      <source srcSet={webpUrl} type="image/webp" />
                      <img src={imageUrl} loading="lazy" alt={Item.game_name ?? ''} onError={handleImageError} />
                    </picture>
                  ) : (
                    <img src={imageUrl} loading="lazy" alt={Item.game_name ?? ''} onError={handleImageError} />
                  )
                )}
                {!didFail && !imageUrl && (
                  <span style={{ fontSize: '10px', color: 'rgba(255,255,255,0.7)', textAlign: 'center' }}>No image</span>
                )}
              </div>
            </a>
          </div>
        )
      })}
      {hasMore && <div ref={loaderRef} style={{ height: 20 }} aria-hidden />}
    </>
  )
}
export default React.memo(CasinoListItemInt)
